export default {
  isId: (id) => /^[a-f0-9]{24}$/.test(id),
  isShortLink: (id) => /^[a-zA-Z0-9]{8}$/.test(id),
  isAllowedVisibilty: (visibility) => ['shared', 'private'].indexOf(visibility) !== -1,
  isAllowedScope: (scope) => ['board', 'card', 'member', 'organization'].indexOf(scope) !== -1,
};
